import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/main/main_layout";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  TextField as MuiTextField,
  Switch,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import DatGridUsers from "./components/datagrid/datagridUsers";
import Loading from "../../components/loading/loading";
import FilterIcon from "../../assets/filter_icon.svg";
import { AddRounded, ArrowBack, Search } from "@mui/icons-material";
import styled from "@emotion/styled";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";
import { useNavigate, useSearchParams } from "react-router-dom";
import FilterUsers from "./components/filter/filterUsers";
import { getMasterData } from "../../services/master/master_service";
import { useQuery } from "react-query";
import {
  appUsersService,
  deleteAppUser,
  downloadAppUsers,
  getAppUsers,
  getUsersDownloadList,
  usersDownload,
} from "../../services/app_users/app_users";
import BlockAppUser from "./components/block_app_user_popup/block_app_user";
import DeleteAppUser from "./components/block_app_user_popup/block_app_user";
import { useFeedback } from "../../providers/feedback/feeedback";
import { queryClient } from "../../providers/query/query";
import { AppUsersList } from "./model/app_users_list_model";
import XLSIcon from "../../assets/xls_icon.svg";
import { downloadFromBlob } from "../../utils/utils";
import useUser from "../../providers/user/user_provider";
import AccessDenied from "../../components/access_denied/access_denied";
import DownloadUsersPopup from "./components/download_users_popup/download_users_popup";
import { create_user } from "../../routes/routes_path";
import { ToolbarButton, SortToggle } from "../../components/toolbar_button/toolbar_button";
import SortIcon from "../../assets/sort.svg";
import { getNeedsFilters } from "../../services/needs/needs_service";
import { NeedFilters } from "../needs/model/needs_filters";
import DataGridDownloads from "./components/data_grid_downloads/data_grid_downloads";
import UsersDownloadFilters from "./components/users_filter_for_downloads/download_filter";
import OrgSelector from "../../components/org_selector/org_selector";
import { useSelectedOrgStore } from "../../store/use-selected-org-store";
import SortUsersPopup, {
  DEFAULT_USERS_SORT_OPTION,
  UsersSortOption,
  usersSortOptionLabel,
  usersSortOptionToParams,
} from "./components/sort_users_popup/sort_users_popup";

export interface UsersLabel {
  label: string;
  flex?: number;
}

const TextField = styled(MuiTextField)(({ theme }) => {
  return {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "transparent", // Border color when focused
      },
      "&:hover fieldset": {
        borderColor: "transparent", // Border color on hover
      },
      "& fieldset": {
        borderColor: "transparent", // Default border color
      },
    },
  };
});
export interface UsersResponseLabel {
  label: string;
}
export default function Users() {
  const { showSnackbar } = useFeedback();
  const { selectedOrgId } = useSelectedOrgStore();
  const [searchParams, setUrlParam] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [schemeKeyword, setSchemeKeyword] = useState("");
  const [stateId, setStateId] = useState<number | null>(null);
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [page, setPage] = useState(searchParams.has("page")
    ? parseInt(searchParams?.get("page")!)
    : 1);
  const [pageSize, setPageSize] = useState(8);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearchValue]);

  useEffect(() => {
    setPage(1);
  }, [pageSize]);

  const [selectedGender, setSelectedGender] = useState<number | null>(null);
  const [blockAppUserDialog, setBlockAppUserDialog] = useState<boolean>(false);
  const [deleteAppUserDialog, setDeleteAppUserDialog] =
    useState<boolean>(false);
  const [blockSubmitting, setBlockSubmitting] = useState<boolean>(false);
  const [deleteSubmitting, setDeleteSubmitting] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<AppUsersList | null>(null);
  const [ageFrom, setAgeFrom] = useState<number | null>(null);
  const [ageTo, setAgeTo] = useState<number | null>(null);
  const [educationId, setEducationId] = useState<number | null>(null);
  const [incomeId, setIncomeId] = useState<number | null>(null);
  const [occupationId, setOccupationId] = useState<number | null>(null);
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);

  const [openDownloadUsersPopup, setOpenDownloadPopup] = useState(false);
  const [cityId, setCityId] = useState<number | null>(null);
  const [sortOption, setSortOption] = useState<UsersSortOption>(DEFAULT_USERS_SORT_OPTION);
  const [openSortModal, setOpenSortModal] = useState(false);
  const [sortInAccedingForDownloads, setSortInAccedingForDownloads] = useState(true);
  const [districtId, setDistrictId] = useState<number | null>(null);
  const { hasPermission } = useUser();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = React.useState(0);
  const [openModelForDownloads, setOpenModalForDownloads] = useState(false);
  const [pageForDownloads, setPageForDownloads] = useState(1);
  const [status, setStatus] = useState<number | null>(null);
  const [startDateForDownloads, setStartDateForDownloads] = useState("");
  const [endDateForDownloads, setEndDateForDownloads] = useState("");
  const [exportSubmitting, setExportSubmitting] = useState(false);

  useEffect(() => {
    setPage(1);
    setPageForDownloads(1);
  }, [selectedOrgId]);

  const activeFilterCount = [
    !!categoryId,
    !!stateId,
    !!schemeKeyword,
    !!(startDate && endDate),
    ageFrom !== null,
    ageTo !== null,
    !!educationId,
    !!incomeId,
    !!occupationId,
    !!selectedGender,
    !!cityId,
    !!districtId,
    isSubscribed,
  ].filter(Boolean).length;

  const activeDownloadFilterCount = [
    status,
    startDateForDownloads && endDateForDownloads,
  ].filter(Boolean).length;



  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
  };


  const { data: masterDataList } = useQuery(
    // Distinct from the "masterDataList" key used by create_user/modify_user
    // (services/choices/choices_services's getMasterData, a different
    // endpoint with a different shape, e.g. includes areasOfInterest) -
    // sharing that key caused this page's fetch to clobber the cache with
    // this leaner shape, so navigating from here into Add User showed no
    // Areas of Interest options until a hard refresh cleared the cache.
    ["masterSchemesDataList"],
    async () => {
      let response = await getMasterData();
      return response.data.data;
    },
    {
      // Feeds the Filters dialog's dropdowns AND resolves gender_id to a
      // label in the list below, so (unlike the other master-data queries
      // on this page) it can't be deferred until the dialog opens.
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    }
  );

  const { data: needsFilters } = useQuery<NeedFilters>(
    ["needs-filters"],
    async () => {
      let data = await getNeedsFilters();
      return data?.data?.data;
    },
    {
      // Only feeds the Filters dialog's city dropdown — don't fetch until it's opened
      enabled: openModal,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    const newPage = (page).toString();
    setUrlParam({ page: newPage }, { replace: true });
  }, [page, setUrlParam]);


  const { data: usersDownloadList, isLoading: isDownloadsLoading } = useQuery(
    [
      "usersDownloadList",
      sortInAccedingForDownloads,
      startDateForDownloads,
      endDateForDownloads,
      status,
      pageForDownloads,
      selectedOrgId
    ],
    async () => {
      let sortOrder = sortInAccedingForDownloads ? "DESC" : "ASC";
      let response = await getUsersDownloadList({
        page: pageForDownloads,
        size: 8,
        dateFrom: startDateForDownloads,
        dateTo: endDateForDownloads,
        sortOrder: sortOrder,
        status: status,
        orgId: selectedOrgId
      });
      return response.data.data?.data;
    },
    {
      // Downloads tab is lazy — don't hit the API while the Users tab is open
      enabled: currentTab === 1,
      refetchOnWindowFocus: false,
    }
  );

  const { data: appUsers, isLoading } = useQuery(
    [
      "app-Users",
      page,
      pageSize,
      ageFrom,
      ageTo,
      educationId,
      selectedGender,
      incomeId,
      occupationId,
      stateId,
      debouncedSearchValue,
      isSubscribed,
      sortOption,
      startDate,
      endDate,
      cityId,
      districtId,
      selectedOrgId
    ],
    async () => {
      const { sortBy, sortOrder } = usersSortOptionToParams(sortOption);
      let response = getAppUsers({
        size: pageSize,
        page: page ,
        ageFrom: ageFrom,
        ageTo: ageTo,
        educationId: educationId,
        gender_id: selectedGender,
        incomeId: incomeId,
        occupationId: occupationId,
        stateId: stateId,
        keyword: debouncedSearchValue,
        isSubscribed: isSubscribed,
        sortBy: sortBy,
        sortOrder: sortOrder,
        startDate: startDate,
        endDate: endDate,
        city: cityId,
        district: districtId,
        orgId: selectedOrgId
      }).then((res) => {
        return res.data.data.data;
      });
      return response;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  function usersDownloadApiCall(taskId: number) {
    usersDownload({ taskId: taskId }).then((res) => {
      let extension = ".xlsx";
      downloadFromBlob(res, extension);

    }).catch((e) => { })
  }

  function downloadExcel(fromPage?: number | null, toPage?: number | null) {
    const { sortBy, sortOrder } = usersSortOptionToParams(sortOption);

    setExportSubmitting(true);
    downloadAppUsers({
      page: 1,
      size: 8,
      ageFrom: ageFrom,
      ageTo: ageTo,
      educationId: educationId,
      gender_id: selectedGender,
      incomeId: incomeId,
      occupationId: occupationId,
      stateId: stateId,
      keyword: debouncedSearchValue,
      format: "excel",
      isSubscribed: isSubscribed,
      sortBy: sortBy,
      sortOrder: sortOrder,
      startDate: startDate,
      endDate: endDate,
      city: cityId,
    }).then((response) => {
      showSnackbar(response?.data?.data?.message);
      // The Downloads tab's list is cached (react-query's default staleTime)
      // and keyed independently of this call, so it wouldn't otherwise pick
      // up the task just queued here until the cache naturally expired.
      setPageForDownloads(1);
      queryClient.invalidateQueries({ queryKey: ["usersDownloadList"] });
    }).catch((e) => {
      showSnackbar(
        e?.code === "ECONNABORTED"
          ? "The export is taking longer than expected — check the Downloads tab shortly."
          : e?.response?.data?.error?.message ||
              "Something went wrong while exporting users."
      );
    }).finally(() => setExportSubmitting(false));
  }

  function deleteAppUserApiCall(comments: string) {
    setDeleteSubmitting(true);
    deleteAppUser({ userId: +selectedUser?.id!, comments: comments })
      .then((res) => {
        if (res.status === 200) {
          showSnackbar("User deleted successsfully");
          queryClient.invalidateQueries({ queryKey: ["app-Users"] });
          setDeleteAppUserDialog(false);
        } else {
          showSnackbar("Something went wrong");
        }
      })
      .catch((e) => {
        showSnackbar("Something went wrong");
      })
      .finally(() => {
        setDeleteSubmitting(false);
      });
  }

  const updateUserAccessApiCall = (comments: string) => {
    setBlockSubmitting(true);
    appUsersService({
      comments: comments,
      isBlocked: !selectedUser?.isBlocked,
      userId: selectedUser?.id!,
    })
      .then((res) => {
        if (res.status === 200) {
          if (selectedUser?.isBlocked) {
            showSnackbar("User Unblocked successfully");
          } else {
            showSnackbar("User blocked successfully");
          }
          queryClient.invalidateQueries({ queryKey: ["app-Users"] });
          setBlockAppUserDialog(false);
        } else {
          showSnackbar("Something went wrong");
        }
      })
      .catch((e) => {
        showSnackbar("Something went wrong");
      })
      .finally(() => {
        setBlockSubmitting(false);
      });
  };

  function updateUserAccess(comments: string) {
    updateUserAccessApiCall(comments);
  }

  const usersLabels: UsersLabel[] = [
    {
      label: "User id",
    },
    {
      label: "Full Name",
      flex: 1.8,
    },
    {
      label: "Contact",
    },
    {
      label: "DOB",
    },
    {
      label: "Gender",
    },
    {
      label: "Marital Status",
    },
    {
      label: "State",
    },
    {
      label: "District",
    },
    {
      label: "Mode of Reg.",
    },
    {
      label: "Phone Type",
    },
    {
      label: "Action",
    },
  ];

  let statusList: { id: number, value: string }[] = [
    {
      id: 1, value: 'Pending'
    },
    {
      id: 2, value: 'Completed'
    },
    {
      id: 3, value: 'Failed'
    }
  ]

  const usersDownloads: { label: string }[] = [
    {
      label: "SL. No",
    },
    {
      label: "Status",
    },
    {
      label: "Remark",
    },

    {
      label: "Processed By",
    },
    {
      label: "Processed At",
    },
    {
      label: "Record Count",
    },
    {
      label: "Action",
    },
  ];

  const handleBackClick = () => {
    const currPage = Number(searchParams.get("page")) || 1;

    if (currPage > 1) {    
      const newPage = currPage - 1;
      if(currentTab==0){
        setPage(newPage);
      }  else{
        setPageForDownloads(newPage)
      }
      setUrlParam({page:newPage.toString()})
    }
  };

  function searchComponent() {
    return (
      <TextField
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        size="small"
        fullWidth
        sx={{
          maxWidth: 420,
          backgroundColor: purpleLight,
          borderRadius: 3,
          borderColor: "transparent",
        }}
        placeholder="Search by username or contact number"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: "text.primary" }} />
            </InputAdornment>
          ),
        }}
      />
    );
  }
  return (
    <MainLayout>
      {hasPermission("users", "read") ? (
        <Box>
          <Box display="flex" alignItems="center" gap={1}>
            {page > 1 && (
              <IconButton onClick={handleBackClick}>
                <ArrowBack />
              </IconButton>
            )}
            <Box>
              <Typography variant="h5" fontWeight={700} color={black}>
                Users
              </Typography>
              <Typography variant="body2" color={greyEnabled} mt={0.5}>
                Manage registered app users and their data-download requests.
              </Typography>
            </Box>
          </Box>

          <Card
            elevation={0}
            sx={{
              mt: 2,
              width: "100%",
              minHeight: 600,
              borderRadius: 3,
              border: "1px solid #ECECEC",
            }}
          >
            <Box px={3} pt={1}>
              <Tabs
                value={currentTab}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: { backgroundColor: purple, height: 3, borderRadius: 3 },
                }}
              >
                <Tab
                  label="Users Details"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color: greyEnabled,
                    "&.Mui-selected": { color: purple },
                  }}
                />
                <Tab
                  label="Downloads"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color: greyEnabled,
                    "&.Mui-selected": { color: purple },
                  }}
                />
              </Tabs>
            </Box>
            <Divider />

            {currentTab === 0 && (
              <Box p={3}>
                <Box
                  display="flex"
                  flexWrap="wrap"
                  justifyContent="space-between"
                  alignItems="center"
                  gap={2}
                  mb={2.5}
                >
                  {searchComponent()}
                  <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                    <OrgSelector lockToOwnOrg />
                    <ToolbarButton
                      icon={XLSIcon}
                      label="Export"
                      onClick={() => downloadExcel()}
                      loading={exportSubmitting}
                      disabled={exportSubmitting}
                    />
                    <ToolbarButton
                      icon={SortIcon}
                      label={usersSortOptionLabel(sortOption)}
                      onClick={() => setOpenSortModal(true)}
                    />
                    <ToolbarButton
                      icon={FilterIcon}
                      label="Filters"
                      badgeCount={activeFilterCount}
                      onClick={() => setOpenModal(true)}
                    />
                    <Button
                      variant="contained"
                      disableElevation
                      startIcon={<AddRounded />}
                      onClick={() => navigate(create_user)}
                      sx={{
                        bgcolor: purple,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        "&:hover": { bgcolor: "#7A2074" },
                      }}
                    >
                      Create User
                    </Button>
                  </Box>
                </Box>
                {isLoading ? (
                  <Loading />
                ) : (
                  <DatGridUsers
                    labels={usersLabels}
                    data={appUsers?.list || []}
                    count={appUsers?.total || 0}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setBlockAppUserDialog={setBlockAppUserDialog}
                    blockAppUserDialog={blockAppUserDialog}
                    setSelectedUser={setSelectedUser}
                    setDeletePopUp={setDeleteAppUserDialog}
                    genderList={masterDataList?.gender}
                  />
                )}
              </Box>
            )}
            {currentTab === 1 && (
              <Box p={3}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={1.5}
                  mb={2.5}
                  flexWrap="wrap"
                >
                  <OrgSelector lockToOwnOrg />
                  <SortToggle
                    ascending={sortInAccedingForDownloads}
                    onToggle={() => setSortInAccedingForDownloads(!sortInAccedingForDownloads)}
                  />
                  <ToolbarButton
                    icon={FilterIcon}
                    label="Filters"
                    badgeCount={activeDownloadFilterCount}
                    onClick={() => setOpenModalForDownloads(true)}
                  />
                </Box>
                {isDownloadsLoading ? (
                  <Loading />
                ) : (
                  <DataGridDownloads
                    count={usersDownloadList?.total || 0}
                    data={usersDownloadList?.list || []}
                    labels={usersDownloads}
                    setPage={setPageForDownloads}
                    page={pageForDownloads}
                    downloadResponse={(id) => {
                      usersDownloadApiCall(id)
                    }}
                  />
                )}
              </Box>
            )}
          </Card>
        </Box>
      ) : (
        <Box display="flex" flex={1} width="100%" height="100%">
          <AccessDenied />
        </Box>
      )}

      <SortUsersPopup
        open={openSortModal}
        onClose={() => setOpenSortModal(false)}
        sortOption={sortOption}
        setSortOption={(option) => {
          setSortOption(option);
          setPage(1);
        }}
      />

      <FilterUsers
        districtId={districtId}
        setDistrictId={setDistrictId}
        cityId={cityId}
        setCityId={setCityId}
        cities={needsFilters?.cityList || []}
        openModal={openModal}
        setOpenModal={setOpenModal}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        schemeKeyword={schemeKeyword}
        setSchemeKeyword={setSchemeKeyword}
        states={masterDataList?.state || []}
        education={masterDataList?.education || []}
        category={masterDataList?.schemeCategory || []}
        income={masterDataList?.personalIncome || []}
        stateId={stateId}
        setStateId={setStateId}
        categoryId={categoryId}
        setCategoryId={setCategoryId}
        resetFilter={() => {
          setCategoryId(null);
          setStateId(null);
          setSchemeKeyword("");
          setStartDate("");
          setEndDate("");
          setOccupationId(null);
          setIncomeId(null);
          setAgeFrom(null);
          setAgeTo(null);
          setSelectedGender(null);
          setEducationId(null);
          setIsSubscribed(false);
          setCityId(null)
        }}
        genderList={masterDataList?.gender}
        selectedGender={selectedGender}
        setSelectedGender={setSelectedGender}
        setAgeFrom={setAgeFrom}
        setAgeTo={setAgeTo}
        setEducationId={setEducationId}
        setIncomeId={setIncomeId}
        setOccupationId={setOccupationId}
        occupation={masterDataList?.occupation || []}
        setPage={setPage}
        isSubscribed={isSubscribed}
        setIsSubscribed={setIsSubscribed}
      />

      <BlockAppUser
        open={blockAppUserDialog}
        onDialogClose={() => {
          setBlockAppUserDialog(false);
        }}
        updateUserAccess={updateUserAccess}
        title={
          selectedUser?.isBlocked
            ? "Are you sure you want to unblock this user?"
            : "Are you sure you want to block this user?"
        }
        submitBtnLabel={selectedUser?.isBlocked ? "Unblock" : "Block"}
        tone={selectedUser?.isBlocked ? "success" : "danger"}
        submitting={blockSubmitting}
      />
      <UsersDownloadFilters
        status={status}
        setStatus={setStatus}
        statusList={statusList}
        openModal={openModelForDownloads}
        setOpenModal={setOpenModalForDownloads}
        startDate={startDateForDownloads}
        setStartDate={setStartDateForDownloads}
        endDate={endDateForDownloads}
        setEndDate={setEndDateForDownloads}
        resetFilter={() => {
          setStartDateForDownloads("");
          setEndDateForDownloads("");
          setPageForDownloads(1);
          setStatus(null)
        }}
      />
      <DeleteAppUser
        open={deleteAppUserDialog}
        onDialogClose={() => {
          setDeleteAppUserDialog(false);
        }}
        updateUserAccess={(remarks) => {
          deleteAppUserApiCall(remarks);
        }}
        title="Are you sure you want to Delete this user?"
        submitBtnLabel={"Delete"}
        tone="danger"
        submitting={deleteSubmitting}
      />
      <DownloadUsersPopup
        onDialogClose={() => {
          setOpenDownloadPopup(false);
        }}
        open={openDownloadUsersPopup}
        key={1}
        onSubmit={(fromPage: number | null, toPage: number | null) => {
          downloadExcel();
        }}
      />
    </MainLayout>
  );
}
